<img
	[attr.aria-labelledby]="uniqueIdentifier"
	[alt]="bonusProductModel?.name"
	[src]="bonusProductModel?.thumbnailImage"
	*ngIf="bonusProductModel?.thumbnailImage"
/>

<div class="bonusProduct-Form">
	<p [id]="uniqueIdentifier" [innerHTML]="bonusProductModel?.message"></p>
	<form [formGroup]="form" cdxForm>
		<form-radio-group
			[orientation]="orientation"
			[defaultValue]="defaultValue"
			[options]="options"
			[groupName]="uniqueIdentifier"
		></form-radio-group>
		<form-input-error validation [control]="uniqueIdentifier">
			<p [cdxInvalidType]="'serverError'" i18n="@@reviewOrder-bonusProductServerErrorMessage">
				Something went wrong. For further assistance, please call 0800 40 40 40.
			</p>
		</form-input-error>
	</form>
</div>
